import { types, async } from "../utils/type-creator";

export default types(
  [
    ...async("GET_GROUPS_OPTIONS"),
    ...async("GET_OPTIONS"),
    ...async("REGISTER"),
  ],
  "GROUPS"
);
